// AUTO-GENERATED by scripts/write-build-version.ts — do not edit.
// Empty string = version key disabled (current/pre-deploy-skew behaviour).
export const BUILD_VERSION = "da9b4397baf4d4da43ea215483feeef9";
// The git sha, ALWAYS — BUILD_VERSION is a render-identity hash under
// CACHE_NAMESPACE_PIN=1 and cannot be compared against a commit.
export const BUILD_COMMIT = "32ab6bd466d4";
